/** What this adapter needs from a recorder, expressed as registration methods rather than the
 * settable `on*` properties `MediaRecorder` actually exposes: it keeps a test double a handful of
 * methods away, with no native event object to fabricate. */
type CaptureRecorder = {
	readonly state: 'inactive' | 'recording' | 'paused';
	start(timesliceMs?: number): void;
	stop(): void;
	pause(): void;
	resume(): void;
	onDataAvailable(listener: (chunk: Blob) => void): void;
	onError(listener: () => void): void;
	onStop(listener: () => void): void;
};

/**
 * Adapts a native `MediaRecorder` into the registration-based `CaptureRecorder` shape: one state
 * accessor, plus a registration for each of the three events the adapter listens to.
 */
const wrapNativeRecorder = (recorder: MediaRecorder): CaptureRecorder => ({
	get state() {
		return recorder.state;
	},
	start: (timesliceMs) => recorder.start(timesliceMs),
	stop: () => recorder.stop(),
	pause: () => recorder.pause(),
	resume: () => recorder.resume(),
	onDataAvailable: (listener) => {
		recorder.ondataavailable = (event) => listener(event.data);
	},
	onError: (listener) => {
		recorder.onerror = () => listener();
	},
	onStop: (listener) => {
		recorder.onstop = () => listener();
	},
});

export default wrapNativeRecorder;
export type { CaptureRecorder };
